import { GeoCookieFactory } from "cookiesConsent/infrastructure/edgeGeo/GeoCookie"
import { VisitorPrivacyContext } from "cookiesConsent/domain/VisitorPrivacyContext"

export const currentGeo = (): VisitorPrivacyContext =>
  new GeoCookieFactory().current().context()
